import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { useTransitionStore } from "gatsby-plugin-transitions"
import { getRoutesQuery } from "../../../utils"
import BazierEasing from "bezier-easing"
import { getLangFromPath } from "../../../utils"

export const tranistionAnimations = direction => {
  switch (direction) {
    case "nextPage":
      return {
        enter: {
          opacity: 1,
          transform: "translate3d(0,0.1vh,0)",
          config: {
            duration: 1000,
          },
          onStart: () => {
            const wrapper = document.querySelectorAll(".view-container")[1]
            if (wrapper) wrapper.classList.add("onTop")
          },
          onRest: () => {
            const wrapper = document.querySelectorAll(".view-container")[1]
            if (wrapper) wrapper.classList.remove("onTop")
          },
        },
        usual: {
          opacity: 1,
          transform: "translate3d(0vh,0vh,0)",
        },
        leave: {
          opacity: 1,
          transform: "translate3d(0vh,-100vh,0)",
          config: {
            mass: 1,
            tension: 220,
            clamp: true,
            duration: 1000,
            easing: t => BazierEasing(0.82, 0.0, 0.195, 1.0)(t),
          },
        },
      }

    case "prevPage":
      return {
        enter: {
          opacity: 1,
          transform: "translate3d(0,-100vh,0)",
          config: {
            mass: 1,
            tension: 220,
            clamp: true,
            duration: 1000,
            easing: t => BazierEasing(0.82, 0.0, 0.195, 1.0)(t),
          },
          onStart: () => {
            const wrapper = document.querySelectorAll(".view-container")[0]
            if (wrapper) wrapper.classList.add("onTop")
          },
          onRest: () => {
            const wrapper = document.querySelectorAll(".view-container")[0]
            if (wrapper) wrapper.classList.remove("onTop")
          },
        },
        usual: {
          opacity: 1,
          transform: "translate3d(0vh,0vh,0)",
        },
        leave: {
          opacity: 1,
          transform: "translate3d(0vh,-0.1vh,0)",
          config: {
            duration: 1000,
            clamp: true,
          },
        },
      }

    default:
      return {
        enter: {
          opacity: 1,
          transform: "translate3d(0,0.1vh,0)",
          config: {
            duration: 1000,
          },
        },
        usual: {
          opacity: 1,
          transform: "translate3d(0vh,0vh,0)",
        },
        leave: {
          opacity: 1,
          transform: "translate3d(0vh,-100vh,0)",
          config: {
            mass: 1,
            tension: 220,
            clamp: true,
            duration: 1000,
            easing: t => BazierEasing(0.82, 0.0, 0.195, 1.0)(t),
          },
        },
      }
  }
}

const ScrollTransition = ({ path }) => {
  const [, dispatch] = useTransitionStore()
  const [selectedLocale, setSelectedLocale] = useState(null)
  const [isReadyTransition, setReadyTransition] = useState(true)
  const isModalClose = useSelector(state => !state.showModal)
  const splitPath = getLangFromPath()

  useEffect(() => {
    if (isReadyTransition === false) {
      setTimeout(() => {
        setReadyTransition(true)
      }, 2500)
    }
  }, [isReadyTransition])

  const query = getRoutesQuery()

  const setCurrentLang = () => {
    splitPath && setSelectedLocale(splitPath)
  }
  const routes = selectedLocale
    ? Object.values(query.chapter[selectedLocale.toLowerCase()].navigation)
    : []

  const getCurrentRoutesIndex = () =>
    routes.findIndex(({ route }) => encodeURI(route.content) === path)

  const nextPagePath = () => {
    const currentIndex = getCurrentRoutesIndex()
    if (currentIndex < routes.length - 1) {
      return routes[currentIndex + 1].route.content
    }
    return path
  }
  const prevPagePath = () => {
    const currentIndex = getCurrentRoutesIndex()
    if (currentIndex > 0) {
      return routes[currentIndex - 1].route.content
    }
    return path
  }

  useEffect(() => setCurrentLang(), [path])

  useEffect(() => {
    const changePageOnArrowClick = event => {
      if (event.key === "ArrowUp") {
        if (
          isReadyTransition &&
          isModalClose &&
          path.split("/").filter(a => a.length > 0).length > 1
        ) {
          dispatch({
            type: "NAVIGATE",
            to: prevPagePath(),
            ...tranistionAnimations("prevPage"),
          })
          setReadyTransition(false)
        }
      } else if (event.key === "ArrowDown") {
        if (
          isReadyTransition &&
          isModalClose &&
          path.split("/").filter(a => a.length > 0).length > 1
        ) {
          dispatch({
            type: "NAVIGATE",
            to: nextPagePath(),
            ...tranistionAnimations("nextPage"),
          })
          setReadyTransition(false)
        }
      }
    }
    window.addEventListener("keydown", changePageOnArrowClick)
    return () => {
      window.removeEventListener("keydown", changePageOnArrowClick)
    }
  }, [path, isReadyTransition, selectedLocale, isModalClose])

  useEffect(() => {
    const onScroll = e => {
      if (
        e.deltaY > 1 &&
        isReadyTransition &&
        isModalClose &&
        path.split("/").filter(a => a.length > 0).length > 1
      ) {
        dispatch({
          type: "NAVIGATE",
          to: nextPagePath(),
          ...tranistionAnimations("nextPage"),
        })
        setReadyTransition(false)
      }
      if (
        e.deltaY < -1 &&
        isReadyTransition &&
        isModalClose &&
        path.split("/").filter(a => a.length > 0).length > 1
      ) {
        dispatch({
          type: "NAVIGATE",
          to: prevPagePath(),
          ...tranistionAnimations("prevPage"),
        })
        setReadyTransition(false)
      }
    }
    window.addEventListener("wheel", onScroll)
    return () => window.removeEventListener("wheel", onScroll)
  }, [path, isReadyTransition, selectedLocale, isModalClose])

  return null
}

export default ScrollTransition
